export default {"src":"/_next/static/media/check_filled.72d47adb.svg","height":24,"width":24};